import { Component } from '@theme/component';

class AimImageToggle extends Component {
  // Collection sorting can morph button attributes without replacing this component.
  #viewObserver = new MutationObserver(() => this.updatedCallback());

  connectedCallback() {
    super.connectedCallback();
    this.restoreView();
    this.#viewObserver.observe(this, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-pressed'] });
  }

  updatedCallback() {
    super.updatedCallback();
    this.restoreView();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#viewObserver.disconnect();
  }

  restoreView() {
    let view = document.documentElement.dataset.aimImageView || 'product';
    try {
      view = sessionStorage.getItem('aim-ecom-image-view') === 'model' ? 'model' : 'product';
    } catch { /* Storage is optional. */ }
    this.setView(view);
  }

  showProduct() { this.setView('product'); }
  showModel() { this.setView('model'); }

  setView(view) {
    document.documentElement.dataset.aimImageView = view;
    for (const [button, pressed] of [[this.refs.productButton, view === 'product'], [this.refs.modelButton, view === 'model']]) {
      if (button && button.getAttribute('aria-pressed') !== String(pressed)) {
        button.setAttribute('aria-pressed', String(pressed));
      }
    }
    try { sessionStorage.setItem('aim-ecom-image-view', view); } catch { /* Storage is optional. */ }
  }
}

if (!customElements.get('aim-image-toggle')) {
  customElements.define('aim-image-toggle', AimImageToggle);
}
